import * as auth from 'auth-provider';
const apiURL = process.env.REACT_APP_API_URL;

async function client(endpoint, { method, data, dataType, token, headers: customHeaders, ...customConfig } = {}) {
  const config = {
    method: method,
    body: dataType ? data : data ? JSON.stringify(data) : undefined,
    headers: {
      // Later on we will add Bearer before token
      Authorization: token ? `${token}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };

  // In case of file upload, we let browser handle content-type
  if (dataType === 'formData') delete config.headers['Content-Type'];

  return window.fetch(`${apiURL}/${endpoint}`, config).then(async response => {
    if (response.status === 401) {
      if (window.__dev__) console.log('Error 401');
      await auth.keycloak.logout();
      // refresh the page for them
      window.location.assign(window.location);
      return Promise.reject({ message: 'Please re-authenticate.' });
    }
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return Promise.reject(data);
    }
  });
}

export { client };
